import { useEffect, useRef } from "react";
import { Box, Flex, Icon, IconButton, Tab, TabList, Text, useColorModeValue } from "@chakra-ui/react";
import { FaArrowLeft, FaArrowRight, FaTrash } from "react-icons/fa";
import { styles } from "../../../pages/OrganizationQuestionnaire/components/Categories/components/Steps/TabStepsList";

function NavigationTabList({
                             currentIndex,
                             elements,
                             tabsCollapsed,
                             setTabsCollapsed,
                             tabTitle,
                             subTitleAttribute,
                             requestTabChange,
                             handleDeleteItem
                           }) {
  const listRef = useRef();
  const selectedTabRef = useRef();

  const timelineBg = useColorModeValue("gray.200", "gray.700");

  const indicatorBg = useColorModeValue("white", "gray.800");
  const indicatorSelectedBg = "esg_active";
  const indicatorColor = useColorModeValue("black", "white");
  const indicatorRing = useColorModeValue(
    `0 0 0 0.5rem var(--chakra-colors-white)`,
    `0 0 0 0.5rem var(--chakra-colors-gray-800)`
  );

  useEffect(() => {
    const selectedTab = selectedTabRef.current;
    const tabList = listRef.current;

    if (tabList && selectedTab) {
      tabList.scrollTop = selectedTab.offsetTop;
    }
  }, [currentIndex]);

  return (
    <TabList
      {...styles.tabList({ tabsCollapsed, timelineBg })}
      ref={listRef}
    >
      {elements.map((element, index) => {
        const isSelected = currentIndex === index;
        return (
          <Tab
            key={`tab_${element.id}`}
            {...styles.tab({ focusColor: indicatorSelectedBg })}
            ref={(el) => {
              if (isSelected) {
                selectedTabRef.current = el;
              }
            }}
          >
            <Box
              {...styles.tabContent}
              onClick={() => {
                requestTabChange(index);
              }}
              flexFlow={!element.customTabListSubTitle && !subTitleAttribute ? "row" : null}
              alignItems={!element.customTabListSubTitle && !subTitleAttribute ? "center" : null}
            >
              <Box
                {...styles.tabIndicator({
                  isSelected,
                  indicatorBg,
                  indicatorSelectedBg,
                  indicatorColor,
                  indicatorRing
                })}
                insetBlockStart={!element.customTabListSubTitle && !subTitleAttribute ? null : 4}
              >
                {index + 1}
              </Box>
              <Text as="strong" {...styles.tabTitle({ isSelected })}>
                {element.customTabListTitle ? element.customTabListTitle : `${tabTitle} ${index + 1}`}
              </Text>
              {element.customTabListSubTitle || subTitleAttribute ?
                <Text as="span" {...styles.tabSubTitle({ isSelected })}>
                  {element.customTabListSubTitle ? element.customTabListSubTitle : element[subTitleAttribute]}
                </Text> : null
              }
              {handleDeleteItem ?
                <Icon
                  as={FaTrash}
                  inlineSize="4"
                  blockSize="4"
                  marginInline={4}
                  color={isSelected ? "esg_red" : "esg_gray.400"}
                  opacity={isSelected ? 1 : 0.6}
                  onClick={(e) => {
                    if (isSelected) {
                      e.stopPropagation()
                      handleDeleteItem();
                    }
                  }}
                /> : null
              }
            </Box>
          </Tab>
        );
      })}
      <Tab {...styles.collapseTab({ bg: indicatorBg })}>
        <Flex inlineSize="full">
          <IconButton
            onClick={() => setTabsCollapsed((prev) => !prev)}
            variant="outline"
            size="xs"
            icon={tabsCollapsed ? <FaArrowRight /> : <FaArrowLeft />}
          />
        </Flex>
      </Tab>
    </TabList>
  );
}

export default NavigationTabList;
